import { styled } from '@creditas-ui/system'

import MediasGridComponent from '../components/MediasGrid'

const MediasGrid = styled(MediasGridComponent)`
  grid-template-columns: repeat(6, 1fr);
`

export { MediasGrid }
